import React from "react";
import BannersContainer from "../../components/banners/BannersContainer";

const BannersPage = () => {
  return (
    <BannersContainer />
  );
};

export default BannersPage;